// eslint-disable-next-line import/no-named-as-default
import posthog, { type PostHog } from "posthog-js";

import { POSTHOG_HOST, POSTHOG_KEY } from "./env";

export const posthogClient = posthog.init(POSTHOG_KEY, {
  api_host: POSTHOG_HOST,
}) as PostHog;
